import axios from 'axios';

axios.defaults.headers = { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
const service = axios.create({
  baseURL: "/", //请求地址前缀
  timeout: 50000
});

// 请求拦截器
service.interceptors.request.use(
  config => {

    //添加请求头部参数
    return config;
  },
  error => {

    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(

  response => {
    //拦截到成功的数据
    return response.data;
  },
  error => {
    //拦截到失败的数据
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/util/request.js